import type { ILineItem, IProperties } from "../types/line-item.types";
import { E_SCENARIO } from "../types/line-item.types";

export default class LineItemModel implements ILineItem {
  key: string = '';
  originalProductId: string = '';
  originalProductUrl: string = '';
  sku: string = '';
  quantity: number = 1;
  properties: IProperties = {
    _hidden: {
      originalProductId: '',
      originalProductUrl: '',
      images: [''],
      sku: '',
    },
    _fields: {},
    _resources: [],
    _stateId: [],
    _userId: '',
  };
  countRowsVdp: number = 0;
  scenario: E_SCENARIO = E_SCENARIO.DEFAULT;
  productVariantId: number = 0;
}